<template>
  <DpplSafeHtmlNode
    v-for="(node, index) in parseFull(html)?.nodes || []"
    :key="index"
    :node="node"
  />
</template>

<script setup>
import { parseFull } from '@ui/helpers/htmlParser';
import DpplSafeHtmlNode from './DpplSafeHtmlNode.vue';

defineProps({
  html: { type: String, default: '' },
});
</script>
